import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useStore } from "../../store";
import InlineLoader from "../../components/atoms/inlineLoader";
import ErrorAlert from "../../components/atoms/alerts/errorAlert";
const Login = () => {
    const title = 'Company Login';
    const { layoutStore } = useStore();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    return (
        <>
            <div className="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
                <div className="sm:mx-auto sm:w-full sm:max-w-md">
                    <h1 className='font-black text-2xl text-center cursor-pointer border-b-2 pb-2 text-blue-700'
                    >
                        {title}
                    </h1>
                    <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">Sign in to your account</h2>
                </div>

                <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                    <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                        {error && <ErrorAlert title={error} />}
                        <form className="space-y-6"
                            onSubmit={(e) => {
                                e.preventDefault();
                                setLoading(true);
                                layoutStore.initiateLogin(e.target.email.value, e.target.password.value).then((resp) => {

                                    if (resp.error) {
                                        setError(resp.error);
                                        setLoading(false);
                                    }
                                });
                            }}
                        >
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                    Email address
                                </label>
                                <div className="mt-1">
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        autoComplete="email"
                                        required
                                        className="block w-full appearance-none rounded-md border border-gray-300 hover:border-blue-500 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                                    />
                                </div>
                            </div>

                            <div>
                                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                    Password
                                </label>
                                <div className="mt-1">
                                    <input
                                        id="password"
                                        name="password"
                                        type="password"
                                        autoComplete="current-password"
                                        required
                                        className="block w-full appearance-none rounded-md border border-gray-300 hover:border-blue-500 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                                    />
                                </div>
                            </div>

                            <div className="flex items-center justify-between">

                                <div className="text-sm">
                                    <p
                                        onClick={() => navigate('/password-reset')}
                                        className="font-medium text-blue-600 hover:text-blue-500 cursor-pointer">
                                        Forgot your password?
                                    </p>
                                </div>
                            </div>

                            <div>
                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="flex w-full justify-center rounded-md border border-transparent bg-blue-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                >

                                    {
                                        loading ? "Please wait..." : "Sign in"
                                    }
                                    {
                                        loading && <InlineLoader />
                                    }
                                </button>
                            </div>
                        </form>
                        <div className="mt-3 pt-3  border-t text-center">
                            <p className="text-sm text-gray-600">
                                Don't have an account?{" "}
                                <span
                                    onClick={() => {
                                        navigate("/get-started");
                                    }}
                                    className="cursor-pointer font-medium text-blue-600 hover:text-blue-500">
                                    Sign up
                                </span>
                            </p>
                        </div>
                    </div>
                </div>

                <div className="mt-3 pt-3 text-center">
                    <a className="text-sm text-gray-600"
                        href="https://sponsorlicencecompliance.com/terms"
                        target="_blank"
                    >
                        Terms & Conditions
                    </a>
                </div>

            </div>
        </>
    )
}
export default Login;